import React from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
import commonUtils from "../../helpers/commonUtils";
import { NavLink } from "react-router-dom";
import { Typography } from "@mui/material";
export default function AdminNavigationBar({ getLoggedInUserInfo }) {
  const { localization } = useLanguageContext();

  const configItem = [
    {
      lable: localization.OrganizationManagement,
      path: "/organizationsadmin",
      show: commonUtils.isUserWebsiteAdmin() ? true : false,
    },
    {
      lable: localization.performanceAnalysis,
      path: "/performanceAnalysis",
      show:
        commonUtils.isUserWebsiteAdmin() || commonUtils.isSupportUser()
          ? true
          : false,
    },
    {
      lable: localization.exceptionAnalysis,
      path: "/exceptionAnalysis",
      show:
        commonUtils.isUserWebsiteAdmin() || commonUtils.isSupportUser()
          ? true
          : false,
    },

    {
      lable: "UnSync Inspection",
      path: "/unSync",
      show: commonUtils.isSupportUser() ? true : false,
    },
  ];
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="navbar-brand" style={{ paddingBottom: "0px" }}>
        <h4 className="prueLogoStyle">PRÜFEXPRESS</h4>
        {/* <Logo /> */}
      </div>
      <div>
        <ul
          className="navbar-nav dropdown-menu-right dropdown-menu-container"
          style={{ fontSize: "20px" }}
        >
          {configItem.map((item, index) => {
            if (item.show) {
              return (
                <li className="nav-item " key={index}>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                    style={{ textDecoration: "none" }}
                    to={item.path}
                  >
                    <Typography variant="title-md">{item.lable}</Typography>
                  </NavLink>
                </li>
              );
            }
          })}
        </ul>
      </div>
      <div className="collapse navbar-collapse"></div>
      <div className="collapse navbar-collapse"></div>
      <div className="collapse navbar-collapse"></div>
      <div className="collapse navbar-collapse"></div>
      <div className="collapse navbar-collapse"></div>
      {getLoggedInUserInfo}
    </nav>
  );
}
